import React from 'react'
import ReactDOM from 'react-dom'
import AppProf from './AppProf'
import AppSett from './AppSett'
import AppTerr from './AppTerr'
import './index.css'

const root = document.getElementById('root')

const params = new URLSearchParams(window.location.search)

const App = params.has('sett') ? AppSett : params.has('terr') ? AppTerr : AppProf

const print = params.has('print')

ReactDOM.render(<App print={print} />, root)



// WEBPACK FOOTER //
// ./src/index.js